import { SecurityPolicies } from './services/auth-variables';
import { Routes } from '@angular/router';
import { HasWebAccessGuard } from './guards/hasWebAccess.guard';
import { HasManageOrganizationsOrPremiumServicesGuard } from './guards/hasManageOrganizationsOrPremiumServices.guard';
import { HasFeatureFlagGuard } from './guards/hasFeatureFlag.guard';
import { LoginComponent } from './page/login/login.component';
import { AuthShellComponent } from './auth-shell.component';
import { AnonymousOnlyGuard } from './guards/anonymousOnly.guard';
import { LoggedInGuard } from './guards/loggedin.guard';
import { MustChangePasswordGuard } from './guards/mustChangePassword.guard';
import { LogoutComponent } from './page/logout/logout.component';
import { SecurityPolicyGuard } from './guards/security-policy.guard';

export const childRoutes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./page/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
    data: {
      showTankFilters: true,
    },
    canActivate: [HasWebAccessGuard],
  },
  {
    path: 'tank',
    loadChildren: () =>
      import('./page/tank/tank.module').then((m) => m.TankModule),
  },
  {
    path: 'report',
    data: {
      featureFlag: 'reporting',
      csoRedirect: true,
    },
    loadChildren: () =>
      import('./page/report/report.module').then((m) => m.ReportModule),
    canActivate: [HasFeatureFlagGuard],
  },
  {
    path: 'location',
    loadChildren: () =>
      import('./page/location/locations.module').then((m) => m.LocationModule),
    canActivate: [SecurityPolicyGuard],
    data: {
      securityPolicy: SecurityPolicies.RequiresManageLocations,
    },
  },
  {
    path: 'notifications',
    data: {
      csoRedirect: true,
    },
    loadChildren: () =>
      import('./page/tanknotifications/tank-notifications.module').then(
        (m) => m.TankNotificationsModule,
      ),
  },
  {
    path: 'organization',
    data: { csoRedirect: true },
    loadChildren: () =>
      import('./page/organization/organizations.module').then(
        (m) => m.OrganizationsModule,
      ),
    canActivate: [HasManageOrganizationsOrPremiumServicesGuard],
  },
  // {
  //   path: 'settings',
  //   data: { csoRedirect: true },
  //   loadChildren: () =>
  //     import('./components/settings/settings.module').then(
  //       (m) => m.SettingsModule,
  //     ),
  // },
  {
    path: 'user',
    loadChildren: () =>
      import('./page/user/users.module').then((m) => m.UsersModule),
    canActivate: [SecurityPolicyGuard],
    data: {
      securityPolicy: SecurityPolicies.RequiresManageUsers,
      csoRedirect: true,
    },
  },
  {
    path: 'my-account',
    loadChildren: () =>
      import('./page/user/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('./page/analytics/analytics.module').then(
        (m) => m.AnalyticsModule,
      ),
  },
  {
    // Internal administration dashboard. No nav entry by design — it is reached by URL.
    // The API guards these endpoints with RequireSuperUserOrDev, whose "Dev" half is the
    // server's IsDevelopment flag rather than a user attribute, so it is not expressible
    // client-side; in production that policy reduces to SuperUser exactly.
    path: 'tank-admin',
    loadChildren: () =>
      import('./page/cache-status/cache-status.module').then(
        (m) => m.CacheStatusModule,
      ),
    canActivate: [SecurityPolicyGuard],
    data: {
      securityPolicy: SecurityPolicies.RequireSuperUser,
    },
  },
  {
    // Former path. Kept as a redirect because the console is reached by URL and nothing else
    // links to it, so a stale bookmark is the only way most people get here.
    path: 'cache-status',
    redirectTo: 'tank-admin',
    pathMatch: 'full',
  },
  // {
  //   path: 'sandbox',
  //   loadChildren: () =>
  //     import('./page/sandbox/sandbox.module').then((m) => m.SandboxModule),
  // },
];

export const ROUTES: Routes = [
  {
    path: 'logout',
    component: LogoutComponent,
    data: { titleKey: 'PageTitle.Logout' },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AnonymousOnlyGuard],
    data: { titleKey: 'PageTitle.Login' },
  },
  {
    path: ':theme/login',
    component: LoginComponent,
    canActivate: [AnonymousOnlyGuard],
    data: { titleKey: 'PageTitle.Login' },
  },
  {
    path: ':theme/logout',
    component: LogoutComponent,
    data: { titleKey: 'PageTitle.Logout' },
  },
  {
    path: '',
    component: AuthShellComponent,
    canActivate: [LoggedInGuard],
    canActivateChild: [MustChangePasswordGuard],
    children: [
      // Directly include childRoutes to avoid the spread operator that causes Compodoc parsing issues
      ...childRoutes,
      {
        path: ':theme',
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          // Using direct spread to avoid Compodoc parsing issues
          ...childRoutes,
        ],
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },

];
